<div
  class="banner"
  [class]="'banner banner-' + severity"
  role="status"
  data-test="banner"
>
  <div class="banner-main-content">
    @if (showIcon) {
      <div class="banner-icon-container">
        <fa-icon
          [icon]="severityIcons[severity]"
          class="banner-icon"
          [class]="'banner-icon banner-icon-' + severity"
          data-test="banner-icon"
          [title]="severityIconAria[severity]"
        ></fa-icon>
        <span class="sr-only">{{ severityIconAria[severity] }}</span>
      </div>
    }

    <div class="banner-content">
      <div class="banner-text">
        @if (titleText) {
          <p class="banner-title" data-test="banner-title">
            {{ titleText }}
          </p>
        }

        @if (message) {
          <div class="banner-message" data-test="banner-message">
            @if (isTemplateRef(message)) {
              <ng-container [ngTemplateOutlet]="message"></ng-container>
            } @else {
              <span>{{ message }}</span>
            }
          </div>
        }
      </div>

      <ng-content select="[bannerList]"></ng-content>
      <ng-content select="[bannerActions]"></ng-content>
    </div>
  </div>

  @if (showCloseIcon) {
    <button
      class="banner-close-btn"
      data-test="banner-close-btn"
      (click)="closed.emit()"
      [attr.aria-label]="dismissAria[severity]"
    >
      <fa-icon
        [icon]="closeIcon"
        class="banner-close-icon"
        data-test="banner-close-icon"
      ></fa-icon>
    </button>
  }
</div>
